import { render } from "./JsonFormatter.vue?vue&type=template&id=b50531cc&scoped=true"
import script from "./JsonFormatter.vue?vue&type=script&lang=js"
export * from "./JsonFormatter.vue?vue&type=script&lang=js"

import "./JsonFormatter.vue?vue&type=style&index=0&id=b50531cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50531cc"]])

export default __exports__